import React from 'react';
import Navigation from './Navigation';
import MobileNavigation from './MobileNavigation';

const ResponsiveNavigation = () => {
  return (
    <>
      {/* Desktop Navigation */}
      <div className="hidden lg:block">
        <Navigation />
      </div>
      
      {/* Mobile Navigation */}
      <div className="lg:hidden">
        <MobileNavigation />
      </div>
    </>
  );
};

export default ResponsiveNavigation;